const COLUMNS_GROUPS = [
  {
    id: "date",
    label: "DATE",
    widget: "text",
    width: 150
  },
  {
    id: "retainerinvoicenumber",
    label: "RETAINER INVOICE N0.",
    widget: "text",
    width: 220
  },
  {
    id: "reference",
    label: "REFERENCE#",
    widget: "text",
    width: 180
  },
  {
    id: "customername",
    label: "CUSTOMER NAME",
    widget: "text",
    width: 250
  },
  {
    id: "projectestimate",
    label: "PROJECT/ESTIMATE",
    widget: "text",
    width: 220
  },
  {
    id: "status",
    label: "STATUS",
    widget: "text",
    width: 150
  },
  {
    id: "amount",
    label: "AMOUNT",
    widget: "number",
    width: 150
  },
  {
    id: "balance",
    label: "BALANCE",
    widget: "number",
    width: 150
  }
];

const ROW_DATA = [
  {
    date: "14/12/2025",
    retainerinvoicenumber: "RT-INV-12045",
    reference: "REF-88421",
    customername: "Arvind Textiles",
    projectestimate: "EST-20451",
    status: "Paid",
    amount: 150000,
    balance: 0
  },
  {
    date: "12/12/2025",
    retainerinvoicenumber: "RT-INV-12032",
    reference: "REF-88390",
    customername: "Meenakshi Fabrics",
    projectestimate: "EST-20430",
    status: "Partially Paid",
    amount: 110000,
    balance: 20000
  },
  {
    date: "10/12/2025",
    retainerinvoicenumber: "RT-INV-12010",
    reference: "REF-88340",
    customername: "Prime Garments",
    projectestimate: "EST-20395",
    status: "Unpaid",
    amount: 90000,
    balance: 90000
  }];

export {COLUMNS_GROUPS,ROW_DATA};